import dayjs from 'dayjs'
import 'dayjs/locale/pl'
import 'dayjs/locale/en'

const currentLang = document.documentElement.lang.substring(0, 2)
dayjs.locale(currentLang === 'en' ? 'en' : 'pl')

export const today = dayjs()
export const tomorrow = dayjs().add(1, 'day')

const dateRangeStart = document.querySelector('#dateRangeStart')
const dateRangeEnd = document.querySelector('#dateRangeEnd')

export const setBseWidgetDate = (firstDate = today, secondDate = tomorrow) => {
  dateRangeStart.querySelector('.date-day').textContent = firstDate.format('DD')
  dateRangeStart.querySelector('.date-month').textContent =
    firstDate.format('MMM') + ' `' + firstDate.format('YY')

  dateRangeEnd.querySelector('.date-day').textContent = secondDate.format('DD')
  dateRangeEnd.querySelector('.date-month').textContent =
    firstDate.format('MMM') + ' `' + firstDate.format('YY')
}

